import { useCallback, useEffect, useState } from "react";
import { useWallet } from "use-wallet";
import { useUsersContract } from "./useContract";
import { SendFun, CallFun } from "../utils/contract";
import useWeb3 from "./useWeb3";

function usePkgUsers(address) {
  const { account } = useWallet();
  const contract = useUsersContract(address);


  // 用户自己购买,也可以续购

  const BuyUserPkg = useCallback(
    async (pkgid, amount, share, setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "BuyUserPkg",
        [pkgid, amount, share],
        setLoading
      );
    },
    [account, contract]
  );

  // 用户帮别人购买
  const BuyOtherUserPkg = useCallback(
    async ({ useraddr, pkgid, amount, share }, setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "BuyOtherUserPkg",
        [useraddr, pkgid, amount, share],
        setLoading,
        isErc20 ? null : amount
      );
    },
    [account, contract]
  );

  // 管理员批量导入用户套餐，直接修改数据，用于合约时升级
  const AdminImportUserPkg = useCallback(
    async (useraddr,pkgid,price,sumamount,starttime,endtime, setLoading) => {
      return await SendFun(
        contract,
        account,
        "AdminImportUserPkg",
        [useraddr,pkgid,price,sumamount,starttime,endtime],
        setLoading
      );
    },
    [account, contract]
  );

  // 管理员增加套餐信息
  const UpdatePkg = useCallback(
    async (
       pkgid, price, pkgdays, appgroup,businesstype, daymaxcount, name,desc,ext,owner ,
      setLoading
    ) => {
      return await SendFun(
        contract,
        account,
        "UpdatePkg",
        [pkgid, price, pkgdays, appgroup,businesstype, daymaxcount, name,desc,ext,owner],
        setLoading
      );
    },
    [account, contract]
  );

  // 管理员提现到自己账号 可以终止管理员权限

  const adminWithdraw = useCallback(
    async ({ to, amount }, setLoading) => {
      return await SendFun(
        contract,
        account,
        "adminWithdraw",
        [to, amount],
        setLoading
      );
    },
    [account, contract]
  );

  // 分享人提现奖励

  const shareWithdraw = useCallback(
    async ({ amount }, setLoading) => {
      return await SendFun(
        contract,
        account,
        "shareWithdraw",
        [amount],
        setLoading
      );
    },
    [account, contract]
  );
  // 获得全部用户 1 开始1，1
  const getUserList = useCallback(
    async (start, end,allpkg, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getUserList",
        [start, end,allpkg],
        setLoading
      );
    },
    [account, contract]
  );


  //获得用户数
  const getUserCount = useCallback(
    async (setLoading) => {
      return await CallFun(contract, account, "getUserCount", [], setLoading);
    },
    [account, contract]
  );
    // 获得套餐的用户数
    const getPkgUserCount = useCallback(
      async (pkgid,setLoading) => {
        return await CallFun(contract, account, "getPkgUserCount", [pkgid], setLoading);
      },
      [account, contract]
    );
  // 获得用户套餐信息
  const getUser = useCallback(
    async (useraddr,allpkg, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getUser",
        [useraddr,allpkg],
        setLoading
      );
    },
    [account, contract]
  );
  // 获得用户套餐信息
  const isValidUser = useCallback(
    async (useraddr, setLoading) => {
      return await CallFun(
        contract,
        account,
        "isValidUser",
        [useraddr],
        setLoading
      );
    },
    [account, contract]
  );
  // 获得用户套餐信息
  const isValidUserByPkg = useCallback(
    async (pkgid,useraddr, setLoading) => {
      return await CallFun(
        contract,
        account,
        "isValidUser",
        [pkgid,useraddr],
        setLoading
      );
    },
    [account, contract]
  );
  // 获得用户套餐信息
  const getPkgInfoList = useCallback(
    async (setLoading) => {
      return await CallFun(contract, account, "getPkgInfoList", [], setLoading);
    },
    [account, contract]
  );

  // 获得套餐信息
  const getPkgInfo = useCallback(
    async (pkgid, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getPkgInfo",
        [pkgid],
        setLoading
      );
    },
    [account, contract]
  );


    // 获得用户所有的套餐信息
  const getUsersPkgInfoList = useCallback(
      async (useraddr,all, setLoading) => {
        return await CallFun(
          contract,
          account,
          "getUsersPkgInfoList",
          [useraddr,all],
          setLoading
        );
      },
      [account, contract]
    );

      // 获得用户单一套餐信息
    const getUsersPkgInfo = useCallback(
        async (pkgid,useraddr, setLoading) => {
          return await CallFun(
            contract,
            account,
            "getPkgInfo",
            [pkgid,useraddr],
            setLoading
          );
        },
        [account, contract]
      );
  // 获得分享总数
  const getAllShareCount = useCallback(
    async (share, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getAllShareCount",
        [share],
        setLoading
      );
    },
    [account, contract]
  );

  // 获得分享总数
  const getUserShare = useCallback(
    async (share, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getUserShare",
        [share],
        setLoading
      );
    },
    [account, contract]
  );

  // 获得分享总数
  const getShareCount = useCallback(
    async (share, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getShareCount",
        [share],
        setLoading
      );
    },
    [account, contract]
  );
  // 获得分享列表
  const getShareList = useCallback(
    async (share, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getShareList",
        [share],
        setLoading
      );
    },
    [account, contract]
  );
  // 设置Token
  const getShareRate = useCallback(
    async (share1rate, share2rate, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getShareRate",
        [share1rate, share2rate],
        setLoading
      );
    },
    [account, contract]
  );
  // 设置Token
  const setShareRate = useCallback(
    async (share1rate, share2rate, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setShareRate",
        [share1rate, share2rate],
        setLoading
      );
    },
    [account, contract]
  );

  // 设置Token
  const getLoginAddr = useCallback(
    async (setLoading) => {
      return await CallFun(contract, account, "getLoginAddr", [], setLoading);
    },
    [account, contract]
  );
  // 设置Token
  const setLoginAddr = useCallback(
    async (setLoading) => {
      return await SendFun(contract, account, "setLoginAddr", [], setLoading);
    },
    [account, contract]
  );
  // 设置Token
  const setToken = useCallback(
    async (setLoading) => {
      return await SendFun(contract, account, "setToken", [], setLoading);
    },
    [account, contract]
  );

  // 获得Token
  const getToken = useCallback(
    async (setLoading) => {
      return await CallFun(contract, account, "getToken", [], setLoading);
    },
    [account, contract]
  );

  // 是否禁用
  const getuserStop = useCallback(
    async (user, setLoading) => {
      return await CallFun(
        contract,
        account,
        "getuserStop",
        [user],
        setLoading
      );
    },
    [account, contract]
  );

   // 是否禁用
const setuserStop = useCallback(
    async (user,stop, setLoading) => {
      return await SendFun(
        contract,
        account,
        "setuserStop",
        [user,stop],
        setLoading
      );
    },
    [account, contract]
  );

  

  return {
    userContract: contract,
    BuyUserPkg,
    getPkgUserCount,
    AdminImportUserPkg,
    BuyOtherUserPkg,
    UpdatePkg,
    getPkgInfoList,
    getPkgInfo,
    getUsersPkgInfoList,
    getUsersPkgInfo,
    adminWithdraw,
    shareWithdraw,
    getUserList,
    isValidUserByPkg,
    getUserCount,
    getUser,
    isValidUser,
    getAllShareCount,
    getUserShare,
    getShareCount,
    getShareList,
    getShareRate,
    setShareRate,
    getLoginAddr,
    setLoginAddr,
    getToken,
    setToken,
    getuserStop,
    setuserStop,
  };
}

export default usePkgUsers;
